import { useState } from 'react';
import Button from 'src/components/atoms/Button';
import AddEventDialog from '../organisms/AddEventDialog';
import { useSelector } from 'src/hooks/useSelector';
import { openSnapSell as openSnapSellInParent } from 'src/utils/frame';
import { usePluginConfig } from '../../contexts/pluginContext';

const PUBLISHERS_WITH_ADD_EVENT_DIALOG = [5293];
const LegacyCreateEventButton = (props) => {
  const publisherSettings = useSelector((state) => state.publisherSettings);
  const isIframed = window.self !== window.top;
  const newEventUrl =
    `${process.env.EVVNT_FORM_URL}?` +
    `force_snap_sell&partner=${publisherSettings.api_key}` +
    `&publisher_id=${publisherSettings.publisher.id}`;

  const frameParams = {
    api_key: publisherSettings.api_key,
    publisher_id: publisherSettings.publisher.id,
    primary_button_color: publisherSettings.theme?.plugin_primary_button_color || '#D52E16',
    primary_button_text_color:
      publisherSettings.theme?.plugin_primary_button_text_color || '#ffffff',
  };

  const openSnapSell = () => {
    if (isIframed) {
      window.open(newEventUrl, '_blank');
    } else {
      openSnapSellInParent(frameParams);
    }
  };

  return (
    <>
      <Button onClick={() => openSnapSell()} {...props} text="Create an Event" />
    </>
  );
};

function checkFlagForNewDialog(publisherId) {
  return true; // Globally enabled
}

const CreateEventButton = (props) => {
  const pluginConfig = usePluginConfig();
  const publisher = pluginConfig.publisherSettings.publisher;
  const [showModalForm, setShowModalForm] = useState(false);

  if (checkFlagForNewDialog(publisher.id)) {
    return (
      <>
        <Button onClick={() => setShowModalForm(true)} {...props} text="Create an Event" />
        {showModalForm && <AddEventDialog setShowModalForm={setShowModalForm} />}
      </>
    );
  } else {
    return <LegacyCreateEventButton {...props} />;
  }
};

export default CreateEventButton;
